/**
 * Decorator to intended to debounce window:resize and other @HostListener window events
 * This can be removed if this issue is completed: https://github.com/angular/angular/issues/13248
 * We use this instead of a library decorator e.g. lodash debounce as that does not support multiple instances as described here: 
 * https://engineering.datorama.com/be-aware-of-the-debounce-decorator-6fb24a6d8d5
 * Also useful: https://stackoverflow.com/questions/44634992/debounce-hostlistener-event/44635703
 * 
 * The decorated method will only execute after delayMs after you stop resizing
 * @param delayMs the time in milliseconds by which to debounce the method call
 * @returns 
 */

export function Debounce(delayMs: number = 100): MethodDecorator {
	return function (target: any, propertyKey: string, descriptor: PropertyDescriptor): PropertyDescriptor {
		const original = descriptor.value;
		const key = `__timeout__${propertyKey}`;

		descriptor.value = function (...args: Array<Event>): void {
			clearTimeout(this[key]);
			this[key] = setTimeout(() => original.apply(this, args), delayMs);
		};

		return descriptor;
	};
}
